module.exports = __webpack_public_path__ + "images/backgrounds/ocean/full.8e1fb303bbc0e2d7035c.jpg";